import React, { memo, VFC, useState, useEffect, useCallback } from 'react';
import {
  Center,Spinner,Divider,Text,Box,VStack,
} from '@chakra-ui/react';
import { SearchInput } from '../atoms/input/SearchInput';
import { ErrorDialog } from '../organisms/modal/ErrorDialog';
import { useIssue } from '../../hooks/useIssue';
import { useLoginUser } from "../../hooks/providers/useLoginUserProvider";
import { IssueTable } from "./IssueTable";
import { issueObj, searchParam } from '../../types/issue';
import { useOpelog } from '../../hooks/useOpelog';
import { PrimaryButton } from "../../components/atoms/button/PrimaryButton";

type Props = {
  setDTStr: (dt:string)=>void;
};

export const HistoryTable: VFC<Props> = memo((props) => {
  const { setDTStr } = props;
  const { loginUser } = useLoginUser();
  const [ issueObjList, setIssueObjList ] = useState<Array<issueObj>>([]);
  const { getIssueListResult, executing, errObj, getIssueList } = useIssue();
  const [ searchParam, setSearchParam ] = useState<searchParam>({
    username: '',
    userGroup: '',
    fromDate: '',
    toDate: '',
    buName: '',
    custName: '',
    blankFlag: false,
    cloud_type: '',
    noticeKind: '',
    eval_key: {},
  });
  const [ execFlag, setExecFlag ] = useState(false);
  const [ closeFlag, setCloseFlag ] = useState(false);
  const { OutputOpelog } = useOpelog();

  // API実行準備
  useEffect(() => {
    setExecFlag(true);
  }, []);
    
  // API実行準備
  useEffect(() => {
    if( execFlag && searchParam.fromDate && searchParam.toDate ){
      setExecFlag(false);
      getIssueList(searchParam);
      OutputOpelog( 'issue_history_list', 'reference', '');
    }
  }, [execFlag, searchParam]);

  // 検索実行
  const execSearch = useCallback(() => {
    searchParam.eval_key = {};
    setIssueObjList([]);
    getIssueList(searchParam);
    
  }, [searchParam]);

  // 次を取得
  const getNext = useCallback(() => {
    getIssueList(searchParam);
    
  }, [searchParam]);
    
  useEffect(() => {
    if( getIssueListResult !== null ){
      setDTStr(`（検索時刻：${getIssueListResult.get_data_time} ）`);
      // setIssueObjList(getIssueListResult.aws_fail_list);
      // 前の配列に追加
      setIssueObjList([...issueObjList,...getIssueListResult.aws_fail_list]
        .sort((a,b)=>{
          if( a.group_name < b.group_name ) return 1;
          if( a.group_name > b.group_name ) return -1;
          if( a.start_time < b.start_time ) return 1;
          if( a.start_time > b.start_time ) return -1;
          return 0;
        }));
      searchParam.eval_key = getIssueListResult.eval_key;
      setCloseFlag(false);
    }
  }, [getIssueListResult,setDTStr]);
  
  return (
    <>
      {errObj && !closeFlag ? (
        <ErrorDialog errTitle="クラウド障害履歴取得" errObj={errObj} opeErrMes="" setCloseFlag={setCloseFlag} />
      ) : (
        <>
          <SearchInput
            func='history'
            searchParam={searchParam}
            setSearchParam={setSearchParam}
            defaultSearchDays={loginUser.mypage_search_days}
            maxSearchDays={loginUser.max_group_search_days}
            cloud_list={loginUser.issue_cloud_list}
            executing={executing}
            execSearch={execSearch}
          />
          <Divider orientation="horizontal" mt="10px" />
          {/* 以下リスト */}
          {executing ? (
            <Center h="20vh">
              <Spinner color="teal.500" />
            </Center>
          ) : closeFlag ? (
            <Center>
              <Box>
                <Text>検索条件を指定して絞り込みをお願いいたします。</Text>
              </Box>
            </Center>
          ) : (
            <VStack>
              <IssueTable ptn='history' issueObjList={issueObjList} nextStr={Object.keys(searchParam.eval_key).length ? '＋' : ''} />
              {Object.keys(searchParam.eval_key).length &&
                <PrimaryButton type='ng' onClick={getNext} isLoading={executing}>続きを追加</PrimaryButton>
              }
            </VStack>
          )}
        </>
      )}
    </>
  );
});
